import { Request } from '~src/httpClient/serverApi/requests/Request';
import { IResult } from '~src/httpClient/serverApi/types/IResponse';
import { IFavoriteParams } from '~src/ts/ServerApi/types/actionParams';

export class AddFavoriteRequest extends Request<IFavoriteParams, IResult> {
  constructor(params: IFavoriteParams) {
    super('addFavorite', params);
  }
}
